import * as React from 'react';
import { ValuesOf } from '../utils/typeUtils';
import { SKINS, SIZES } from './ToggleSwitch.constants';

export interface ToggleSwitchProps {
  dataHook?: string;
  className?: string;
  id?: string;
  skin?: ToggleSwitchSkin;
  size?: ToggleSwitchSize;
  checked?: boolean;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  tabIndex?: number;
}

export default class ToggleSwitch extends React.Component<ToggleSwitchProps> {}

export type ToggleSwitchSkin = ValuesOf<typeof SKINS>;
export type ToggleSwitchSize = ValuesOf<typeof SIZES>;
